import { defineComponent, ensureLoadingHasResult, useLoadableRef, type ReactiveComponent } from "vue-utils"
import StateLoading from "../../components/StateLoading"
import PWAViews from "./views"
import type { HomePage, UmbracoContentList } from "../../models"
import Api from "../../api"

const PWA: ReactiveComponent = () => {
	const contentRef = useLoadableRef<UmbracoContentList<HomePage>>(async () => await Api.content.getContent())

	return () => (
		<StateLoading stores={[contentRef]}>
			{ensureLoadingHasResult(contentRef).items[0] != null ? (
				<PWAViews content={ensureLoadingHasResult(contentRef).items[0]!}/>
			) :
			(
				<h2>An error occurred, please contact the administrator</h2>
			)}
		</StateLoading>
	)
}
export default defineComponent(PWA)